import Head from 'next/head'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import { useGetCLItem } from 'api/microlearning/useAPIContextualizedLearning'
import CLRenderer from '../components/CLRenderer'
import { GATrackEvent } from 'utils/googleAnalytics'

const CLStandalone = ({
  onPageLoaded,
}: {
  onPageLoaded?: (title?: string) => void
}) => {
  const { query } = useRouter()
  const clItem = useGetCLItem(Number(query?.contextualizedPageId)).data?.data

  useEffect(() => {
    if (!!clItem?.id) {
      GATrackEvent({
        eventName: 'contextualized_learning',
        eventParams: {
          event_trigger: 'open_kb_page',
          action_type: 'view_kb_page',
          meta: JSON.stringify({
            title: clItem?.title,
            kb_id: clItem?.id,
          }),
        },
        sendDefaultParams: true,
      })
      onPageLoaded?.(clItem?.title)
    }
  }, [onPageLoaded, clItem?.title, clItem?.id])

  return (
    <>
      <Head>
        <title>Pelatihan Mandiri | {clItem?.title}</title>
      </Head>
      <div
        className="relative bg-gray-10 z-0"
        style={{
          minHeight: 'calc(100vh - 3.5rem)',
        }}
      >
        <div>
          <CLRenderer
            clItem={clItem}
            trackerWidgetData={{
              source: 'kb_page',
              kbPageId: clItem?.id,
            }}
          />
        </div>
      </div>
    </>
  )
}

export default CLStandalone
